import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "react-multi-date-picker/styles/layouts/mobile.css"


export default class WorkingDetails extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/working/getworkingview", {
            id: this.getCurrentFormId()
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    async getMaliyat(id) {
        this.setState({ loading: true });

        this.httpPost("api/v1/working/maliyatfile", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    const linkSource = `data:application/zip;base64,${data.bs64}`;
                    const downloadLink = document.createElement("a");
                    const fileName = "Maliat.zip";
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    this.setState({ loading: false });
                }
                else {
                    this.setState({
                        loading: false
                    });
                }
            })
    }
    async getBime(id) {
        this.setState({ loading: true });

        this.httpPost("api/v1/working/bimefile", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    const linkSource = `data:application/zip;base64,${data.bs64}`;
                    const downloadLink = document.createElement("a");
                    const fileName = "Bime.zip";
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    this.setState({ loading: false });
                }
                else {
                    this.setState({
                        loading: false
                    });
                }
            })
    }
    async getPay(id) {
        this.setState({ loading: true });

        this.httpPost("api/v1/working/bankexcel", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    const linkSource = `data:application/vnd.ms-excel;base64,${data.bs64}`;
                    const downloadLink = document.createElement("a");
                    const fileName = "Bank.xlsx";
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    this.setState({ loading: false });
                }
                else {
                    this.setState({
                        loading: false
                    });
                }
            })
    }

    renderForm() {
        return <form method="post" onSubmit={e => this.save(e)} className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block-head nk-block-head-lg wide-sm">
                                <div className="nk-block-head-content">
                                    <div className="nk-block-head-sub">
                                        <NavLink className="back-to" to="/companies/"><em className="icon ni ni-arrow-left"></em><span>فهرست کارگاهای من</span></NavLink>
                                    </div>
                       
                                </div>
                        
                            </div>
                            <div class="card card-bordered card-preview">
                                <div class="card-inner">
                                    <h6 class="title mb-3">عملیات</h6>
                                    <ul class="preview-list">
                                        <li class="preview-item">
                                            <span class="preview-title overline-title">خروجی اکسل</span>
                                            <div class="dropdown-preview">
                                                <div class="dropdown-menu">
                                                    <ul class="link-list-plain no-bdr">
                                                        <li>
                                                            <a href="#"><em class="icon ni ni-setting"></em><span>اکسل</span></a>
                                                        </li>
                                                      
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>

                                        <li class="preview-item">
                                            <span class="preview-title overline-title">بیمه</span>
                                            <div class="dropdown-preview">
                                                <div class="dropdown-menu">
                                                    <ul class="link-list-plain no-bdr">
                                                        <li>
                                                            <a onClick={e => this.getBime(e)}><em class="icon ni ni-setting"></em><span>دیسک بیمه</span></a>
                                                        </li>
                                                        <li>
                                                            <a href="#"><em class="icon ni ni-notify"></em><span>سامانه سازمان تامین اجتماعی</span></a>
                                                        </li>

                                                    </ul>
                                                </div>
                                            </div>
                                        </li>

                                        <li class="preview-item">
                                            <span class="preview-title overline-title">مالیات</span>
                                            <div class="dropdown-preview">
                                                <div class="dropdown-menu">
                                                    <ul class="link-list-plain no-bdr sm">
                                                        <li>
                                                            <a onClick={e => this.getMaliyat(e)} ><em class="icon ni ni-setting"></em><span>دیسک مالیات کلی</span></a>
                                                        </li>
                                                        <li>
                                                            <a href="https://salary.tax.gov.ir/Account/LogOn" target="_blank" rel="noreferrer"><em class="icon ni ni-notify"></em><span>سامانه مالیات بر درآمد حقوق</span></a>
                                                        </li>
             
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>


                                        <li class="preview-item">
                                            <span class="preview-title overline-title">گزارش ها</span>
                                            <div class="dropdown-preview">
                                                <div class="dropdown-menu">
                                                    <ul class="link-list-plain no-bdr sm">
                                                        <li>
                                                            <a href="#"><em class="icon ni ni-setting"></em><span>فایل تجمیعی فیش حقوقی</span></a>
                                                        </li>
                                                        <li>
                                                            <a href="#"><em class="icon ni ni-notify"></em><span>خلاصه گزارش جامع ماه</span></a>
                                                        </li>

                                                    </ul>
                                                </div>
                                            </div>
                                        </li>

                                        <li class="preview-item">
                                            <span class="preview-title overline-title">خروجی بانک</span>
                                            <div class="dropdown-preview">
                                                <div class="dropdown-menu">
                                                    <ul class="link-list-plain no-bdr sm">
                                                        <li>
                                                            <a onClick={e => this.getPay(e)}><em class="icon ni ni-setting"></em><span>اکسل خالص پرداختی حقوق</span></a>
                                                        </li>

                                                    </ul>
                                                </div>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>
                            <br/>
                            <div className="nk-block nk-block-lg" >
                                <div className="card card-bordered" style={{ height: '800px' }}>
                                    <div className="card-inner">
                                        <div className="tab-content">
                                            <div className="tab-pane active" id="base">
                                                <div className="table-responsive" style={{ height: '800px' }}>
                                                    <table class="datatable-init-export nowrap table dataTable no-footer dtr-inline"  >
                                                        <thead>
                                                            <tr style={{ height: '45px', textAlign: 'center', backgroundColor: '#1A237E', color:"#fff" }}>
                                                                <th style={{ border: '0.5px solid #fff', textAlign: 'center' }}>نام پرسنل</th>
                                                                <th style={{ border: '0.5px solid #fff', textAlign: 'center' }}>نام شرکت</th>
                                                                <th style={{ border: '0.5px solid #fff', textAlign: 'center' }}>تجمیع کاکرد</th>
                                                                {this.state.data.records[0].viewWorkingDetails.map((record, index) =>
                                                                    <th style={{ border: '0.5px solid #fff', textAlign: 'center' }}>{record.title}</th>
                                                                )}
                                                                <th style={{ border: '0.5px solid #fff', textAlign: 'center' }}>جمع کسورات</th>
                                                                <th style={{ border: '0.5px solid #fff', textAlign: 'center' }}>خالص پرداخت کاری</th>
                                                                <th style={{ border: '0.5px solid #fff', textAlign: 'center' }}>خالص پرداخت کل</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.data.records.map((record, index) =>
                                                                <tr style={index / 2 == 0 ? { backgroundColor: "#EEEEEE", boxShadow:"1px 1px 2px #000000" } : ""}>
                                                                    <th style={{ border: '0.5px solid #fff', textAlign: 'center', backgroundColor: '#2979FF', color: "#fff" }}>{record.fullPerson}</th>
                                                                    <td style={{ border: '0.5px solid #fff', textAlign: 'center', backgroundColor: '#2979FF', color: "#fff" }}>{record.companyName}</td>
                                                                    <td style={{ border: '0.5px solid #fff', textAlign: 'center' }}>{record.tajmiKarkard}</td>
                                                                    {record.viewWorkingDetails.map((item, index) =>
                                                                        <td style={{ border: '0.5px solid #fff', textAlign: 'center' }}>{item.priceStr}</td>
                                                                    )}
                                                                    <td style={{ border: '0.5px solid #fff', textAlign: 'center' }}>{record.jamKosorAzPardakhtStr}</td>
                                                                    <td style={{ border: '0.5px solid #fff', textAlign: 'center' }}>{record.khalesPardakhtKariStr}</td>
                                                                    <td style={{ border: '0.5px solid #fff', textAlign: 'center' }}>{record.khalesPardakhtKollStr}</td>
                                                                </tr>
                                                            )}


                                                        </tbody>
                                                    </table>
                                                </div>
                                
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    }
  
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}